const React = require('react');
const {
  some,
} = require('mn-utils/Emitter');
const reduce = require('mn-utils/reduce');
const withState = require('./utils/withState');
const setTitle = require('./utils/setTitle');
const {
  replaceLocation,
} = require('./router');
const {
  router$,
} = require('./emitters/router');
const {
  loadingSignOut$,
  account$,
  isUserAccessed,
} = require('./emitters/account');
const {
  popupWindow$,
  popup$,
  adminTerminal$,
} = require('./emitters/popup');
const {
  LINK_SIGN_IN,
  LINK_ACCESS_DENIED,
} = require('./constants/links');


const Loading = require('./components/dumb/Loading');
const AdminLayout = require('./components/smart/Page/Admin');
const MerchantLayout = require('./components/smart/Page/V2');
const PopupWindows = require('./components/smart/Popup/Windows');
const PopupRemove = require('./components/smart/Popup/Remove');
const PopupApprove = require('./components/smart/Popup/Approve');


function Noop(props) {
  return props.children || null;
}

const Router = withState(() => {
  return (state) => {
    const {
      account = {},
    } = state;

    const router = state.router || {};
    const hasPublic = router.public;
    const hasKyc = router.kyc;
    const View = router.main || Noop;
    const Wrapper = hasPublic ? Noop : account.admin ? AdminLayout : MerchantLayout;

    if (state.loading) {
      return (
        <div className="rlv h100vh ovH c0>.CircularProgress">
          <Loading/>
        </div>
      );
    }

    if (!reduce(router.permissions, (a, permission) => {
      return a && isUserAccessed(permission);
    }, true)) {
      replaceLocation({
        path: LINK_ACCESS_DENIED,
      });
    }

    if (hasPublic || account && (account.enabled || hasKyc)) {
      const title = router.title;
      title === undefined || setTitle(title);
      return (
        <Wrapper account={account}>
          <View
            params={router.params || {}}
            location={router.location || {}}
          />
        </Wrapper>
      );
    }

    account === 0 && replaceLocation({
      path: LINK_SIGN_IN,
    });

    return null;
  };
}, {
  router: router$,
  account: account$,
  loading: loadingSignOut$,
});


const Wrapper = withState(() => {
  return (state, props) => {
    return (
      <div
        {...props}
        className={'fixed s ovA dn tp_filter (ov|ftBlur14).popup'
          + (state.popup ? ' popup' : '')}
      />
    );
  };
}, {
  popup: some([
    popupWindow$,
    popup$,
    adminTerminal$,
  ]),
});


module.exports = () => {
  return (
    <>
      <Wrapper>
        <Router/>
      </Wrapper>
      <PopupApprove/>
      <PopupRemove/>
      <PopupWindows/>
    </>
  );
};
